<template>
    <header id="siteHeader">
        <div id="homeButton">
            <router-link
                v-if="!checkHome()"
                role="button"
                to="/"
            >Home</router-link>
        </div>
        <div id="loginWrap">
            <router-link
                v-if="!this.authenticated && this.displayHeader"
                id="login"
                class="ui primary"
                role="button"
                to="/login"
            >
                Login
            </router-link>
            <ul id="loggedInOptions" v-if="this.authenticated && this.displayHeader">
                <li class="logged-in-option"><router-link to="/profile">Profile</router-link></li>
                <li class="logged-in-option" v-if="checkAdmin()"><router-link to="/admin">Admin</router-link></li>
                <li class="logged-in-option"><a @click="logout()" href="">Log out</a></li>
            </ul>
        </div>
    </header>
</template>

<script>
    export default {
        name: "page-header",
        data() {
            return {
                displayHeader: false,
                authenticated: false,
                user: null
            };
        },
        computed: {
            // name() { return this.$store.getters["user/getItem"]("first_name"); }
        },
        created() {
            this.isAuthenticated();
        },
        methods: {
            checkHome() {
                return this.$route.path === "/";
            },
            checkAdmin() {
                return this.$store.getters["user/isAdmin"];
            },
            async isAuthenticated() {
                this.authenticated = await this.$auth.isAuthenticated();
                if (this.authenticated) {
                    await this.$store.dispatch("user/initUser");
                    // this.user = await this.$auth.getUser();
                    // this.$auth.getAccessToken().then((data) => { this.$store.commit("user/setAccessData", data); });
                }
                this.displayHeader = true;
            },
            login() {
                this.$auth.loginRedirect(this.$route.path);
            },
            logout() {
                this.$auth.logout();
                this.isAuthenticated();
                // this.$router.push("/");
            }
        },
        watch: {
            "$route": 'isAuthenticated'
        }
    };
</script>

<style scoped lang="less">
    @import (reference) "../assets/variables";
    #siteHeader{
        margin: 1rem 0 0;
        position: relative;
        display:flex;
        justify-content: space-between;
        align-items: center;
        height: 5rem;
        font-size: 1.2rem;
        background: url("../assets/vectors/Treeline-simple.svg") no-repeat 50% 120%;
        border-bottom: 3px solid @light-gray;
    }
    #welcomeBack{
        font-size: 1.2rem;
        margin: 0 0 0.5rem;
        text-align: right;
    }
    #loginWrap{
        text-align: right;
    }
    #loggedInOptions{
        margin: 0;
        list-style: none;
        padding: 0;
        text-align: right;
    }
    .logged-in-option{
        display: inline-block;
        margin: 0 0 0 0.5em;
    }
    a:link, a:visited{
        color: @green;
        background: @light-green;
        padding: 0.25em 0.75em;
        text-decoration: none;
        text-transform: uppercase;
        letter-spacing: 0.07em;
    }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue